import { render, staticRenderFns } from "./AnswerArea.vue?vue&type=template&id=0077809d&"
import script from "./AnswerArea.vue?vue&type=script&lang=js&"
export * from "./AnswerArea.vue?vue&type=script&lang=js&"
import style0 from "./AnswerArea.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports